import { render, staticRenderFns } from "./TemplateReadOnlyPanel.vue?vue&type=template&id=06167178"
import script from "./TemplateReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./TemplateReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports